import 'owa-bootstrap'; // Important that owa-bootstrap come first, in order to bootstrap webpack settings
import 'owa-application'; // Import owa-application here to include globalStyles

// Initialize mail packages here:
import 'owa-mail-list-selection-actions-v2';
import 'owa-calendar-module-selected-calendars-user-config';
import 'owa-mail-nudge-actions';

export { default as bootstrapMailModule } from './bootstrapMailModule';
